import * as yup from 'yup';

/**
 * Validating email following these rules:
 * 1. The input must be a string.
 * 2. The string must be in email format. This involves:
 *    - There must be exactly one '@' symbol.
 *    - There must be at least one character before the '@' symbol.
 *    - After the '@' symbol, there must be a valid domain which contains at least one '.' symbol.
 *    - The domain must have at least one character before and after the '.' symbol.
 *    - There should be no trailing or leading whitespace.
 */
export const validateEmail = (email) => {
  const schema = yup.object().shape({
    email: yup.string().required().email(),
  });
  try {
    schema.validateSync({ email });
    return true;
  } catch (error) {
    return false;
  }
};
